import createWidgetFactory from 'components-framework/widget/create_widget_factory';
import {MembershipHotelBannerView} from './view';

const factory = createWidgetFactory({
    name: 'membership_hotel_banner',
    viewClass: MembershipHotelBannerView,
});

function createEventsMap() {
    return {
        'tap .membership_show_hotels': 'onShowHotels',
    };
}

export default {
    factory,
    createEventsMap,
};
